<template>
  <WhiteIQOS
    :title="$t('menu_tag.title')"
    :subtitle="$t('menu_tag.desc')"
    bodyClass="gap-row-1xs"
  >
    <div class="tag-i18n-row">
      <img
        :src="`/flags/${menu.original_locale}.png`"
        v-if="menu.locales.length"
      />

      <BaseInput
        v-model="tag"
        fullWidth
        :placeholder="$t('menu_tag.ph')"
        v-if="editing"
      />

      <BaseInput
        v-model="tagFromStore"
        fullWidth
        :placeholder="$t('menu_tag.ph')"
        :disabled="true"
        v-if="!editing"
      />
    </div>

    <BaseDivider
      color="v1-grey-3"
      :key="locale + '_divider'"
      v-if="menu.locales.length"
    />

    <template v-for="(locale,index) in menu.locales">
      <div class="tag-i18n-row" :key="locale">
        <img :src="`/flags/${locale}.png`" />

        <BaseInput
          fullWidth
          v-model="tag_i18n[locale]"
          :placeholder="$t('menu_tag.ph')"
          :disabled="!editing"
        />
      </div>
      <BaseDivider color="v1-grey-4" :key="locale + '_divider'" v-if="index != menu.locales.length-1"/>
    </template>

    <!-- <p class="iqos-comment qrw-paragraph-md mt-16">{{  }}</p> -->

    <template #actions>
      <WhiteIQOSActions
        :editing="editing"
        @edit="showEditUI"
        @accept="onEditFinish"
        @cancel="hideEditUI"
      />
    </template>
  </WhiteIQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import IQOSActions from "@/components/IQOSActions.vue";

import BlackInput from "@/components/BlackInput.vue";

export default {
  data() {
    return {
      editing: false,

      tag: null,

      tag_i18n: {},
    };
  },
  methods: {
    showEditUI() {
      this.editing = true;
      this.reset();
    },
    hideEditUI() {
      this.editing = false;
      this.reset();
    },
    onEditFinish() {
      this.editing = false;

      this.$store.commit("menu/setMenuTag", {
        menu_id: this.$store.state.menu.current._id,
        tag: this.tag,
      });
      this.$store.commit("menu/setTagLocaliztion", this.tag_i18n);
      this.$store.dispatch("menu/save");

      this.$store.dispatch("auditlog/write", {
        type: "menu_tag",
        payload: {
          tag: this.tag,
        },
      });
    },
    reset() {
      this.tag = this.$store.state.menu.current.tag || null;

      if (this.menu.tag_i18n) {
        this.tag_i18n = Object.assign({}, this.menu.tag_i18n);
      }
    },
  },
  watch: {
    menu() {
      this.reset();
    },
  },
  computed: {
    tagFromStore() {
      return this.$store.state.menu.current.tag;
    },
    menu() {
      return this.$store.state.menu.current;
    },
  },
  mounted() {
    this.reset();
  },
  components: {
    IQOS,
    BlackInput,
    IQOSActions,
  },
};
</script>

<style>
.tag-i18n-row {
  display: flex;

  align-content: center;
  align-items: center;
}

.tag-i18n-row img {
  width: 24px;
  height: 24px;
  margin-right: 8px;
  max-width: 24px;
  min-width: 24px;
  max-height: 24px;
  max-width: 24px;
}
</style>